export const blogCategoryDefinitions = [
  {
    value: 'High-Intent',
    label: 'Platform Comparisons',
    slug: 'platform-comparisons',
  },
  {
    value: 'How-To Guides',
    label: 'Website & Setup Guides',
    slug: 'website-setup-guides',
  },
  {
    value: 'Listicles',
    label: 'Tools & Shortlists',
    slug: 'tools-shortlists',
  },
  {
    value: 'State-Based SEO',
    label: 'Nonprofit Operations',
    slug: 'nonprofit-operations',
  },
  {
    value: 'Educational / Authority',
    label: 'Fundraising Strategy',
    slug: 'fundraising-strategy',
  },
] as const

export type BlogCategory = (typeof blogCategoryDefinitions)[number]['value']

export const blogCategoryOptions = blogCategoryDefinitions.map(
  ({ value }) => value,
) as BlogCategory[]

export function getBlogCategoryLabel(category: BlogCategory) {
  return blogCategoryDefinitions.find(({ value }) => value === category)!.label
}

export function getBlogCategorySlug(category: BlogCategory) {
  return blogCategoryDefinitions.find(({ value }) => value === category)!.slug
}

/** Accept current public slugs plus old query values so shared links keep working. */
export function resolveBlogCategory(value: string | null): BlogCategory | null {
  if (!value) {
    return null
  }

  return blogCategoryDefinitions.find(
    (definition) => definition.slug === value || definition.value === value,
  )?.value ?? null
}
